// extracted by mini-css-extract-plugin
export default {"appContainer":"App_appContainer__HT9DU","mainContent":"App_mainContent__GwoCn","fadeIn":"App_fadeIn__NgPq7","contentCard":"App_contentCard__j6pGA shared_contentCard__DVdmU"};